import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";

import { Dialog, Typography } from "@mui/material";
import { yellow } from "@mui/material/colors";

// 取引先削除ダイアログ
// props...
//   open = ダイアログが開いていればtrue
//   customerData = 取引先データ
export default function DeleteCustomerDialog({
  open,
  onCloseDialog,
  customer,
  deleteAction,
}) {
  const { customerName } = customer;

  const onClickDelete = (event) => {
    deleteAction();
    alert(`取引先を削除しました。\n取引先名: ${customerName}`);
    onCloseDialog(event);
  };

  const onCloseCancel = (event) => {
    onCloseDialog(event);
  };

  return (
    <Dialog open={open} onClose={onCloseCancel}>
      <Box padding={2} minWidth={400}>
        <Typography fontSize={20} fontWeight={700}>
          取引先削除
        </Typography>
        <Box marginTop={2} marginBottom={1}>
          <Typography>以下の取引先を削除します。</Typography>
          <Box backgroundColor={yellow[100]} marginY={1} padding={1}>
            <Typography fontSize={20}>取引先名:&nbsp;{customerName}</Typography>
          </Box>
        </Box>

        <Grid container>
          <Grid item xs textAlign="center">
            <Button variant="contained" color="error" onClick={onClickDelete}>
              削除
            </Button>
          </Grid>
          <Grid item xs textAlign="center">
            <Button variant="outlined" onClick={onCloseCancel}>
              戻る
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  );
}
